export class UserLoggedOutEvent {}
